// removed by extract-text-webpack-plugin
module.exports = {"BuildControls":"BuildControls__BuildControls__3_01f","GridOfBuildControls":"BuildControls__GridOfBuildControls__2tANR","Price":"BuildControls__Price__3dq_j","OrderButton":"BuildControls__OrderButton__myBwT","enable":"BuildControls__enable__3jYIq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BuildControls/BuildControls.css
// module id = 308
// module chunks = 3